module.exports = __webpack_public_path__ + "Simple-Line-Icons.woff";


//////////////////
// WEBPACK FOOTER
// ./~/simple-line-icons/fonts/Simple-Line-Icons.woff?v=2.4.0
// module id = 1246
// module chunks = 8